import React from 'react';

export function FieldError({ show, children, className = '' }) {
  if (!show) return null;
  return (
    <p className={`text-sm text-destructive mt-1 ${className}`.trim()}>
      {children}
    </p>
  );
}
